import { Component } from 'react'

import classNames from 'classnames'
import PropTypes from 'prop-types'

import { formatNameWithCode } from 'utils/formatters'

import DetailedItemList from 'components/Core/DetailedItemList/DetailedItemList'
import TruncateWithTooltip from 'components/Core/TruncateWithTooltip/TruncateWithTooltip'

import messages from './RemoveStyleColorsWithoutQuantitiesList.messages'
import styles from './RemoveStyleColorsWithoutQuantitiesList.module.css'

class RemoveStyleColorsWithoutQuantitiesList extends Component {
  renderStyle = (style) => (
    <DetailedItemList.ParentItem
      title={style.name}
      description={style.code}
      image={style.image}
    />
  )

  renderStyleColors = (styleColors, orderId) =>
    styleColors.map((styleColor) => (
      <DetailedItemList.Item
        id={styleColor.id}
        key={`${orderId}-${styleColor.id}`}
        title={
          <TruncateWithTooltip lines={1} className={styles.Item}>
            {formatNameWithCode(styleColor.name, styleColor.code)}
          </TruncateWithTooltip>
        }
        onClick={() =>
          this.props.toggleStyleColor({
            orderId,
            styleColorId: styleColor.id,
          })
        }
        isSelectable={!this.props.review}
        isSelected={
          !this.props.review &&
          this.props.isStyleColorSelected(orderId, styleColor.id)
        }
        swatch={styleColor.swatch}
      />
    ))

  render() {
    const { orders } = this.props
    return (
      <>
        {orders.map((order) => (
          <DetailedItemList
            key={order.id}
            className={classNames(
              'notranslate',
              styles.detailedItemListContainer,
            )}
          >
            <DetailedItemList.Header>
              {`${messages.poNumber} ${order.referenceNumber}`}
            </DetailedItemList.Header>
            {order.uniqueStyles.map((style) => (
              <DetailedItemList.Row key={`${order.id}-${style.id}`}>
                {this.renderStyle(style)}
                <DetailedItemList.List>
                  {this.renderStyleColors(style.styleColors, order.id)}
                </DetailedItemList.List>
              </DetailedItemList.Row>
            ))}
          </DetailedItemList>
        ))}
      </>
    )
  }
}

RemoveStyleColorsWithoutQuantitiesList.propTypes = {
  orders: PropTypes.array.isRequired,
  isStyleColorSelected: PropTypes.func,
  toggleStyleColor: PropTypes.func,
  review: PropTypes.bool,
}

RemoveStyleColorsWithoutQuantitiesList.defaultProps = {
  isStyleColorSelected: () => {},
  toggleStyleColor: () => {},
  review: false,
}

export default RemoveStyleColorsWithoutQuantitiesList
